/**
 * SGKC019A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SlidecalculationDetailsinformationDto {

    /**
     * スライド算定諸元コード
     */
    slidecalculationDetailscode?: string;
    /**
     * スライド算定諸元情報
     */
    slidecalculationDetailsinformation?: string;
}

